// Pure (no import.meta.env): infra/scripts env-example, env-check and deploy
// import this schema. The logging modules read VITE_LOG_* and
// VITE_APP_VERSION raw from import.meta.env, because they evaluate before
// anything else and must not throw on a bad value; env.ts leaves them out.
import * as z from "zod";
import { envField } from "@bindery/shared/env";

export const envSchema = z.object({
  VITE_CONVEX_URL: envField(z.url(), {
    kind: "build",
    doc: "The convex-reader deployment URL this build talks to. `bunx convex dev` in packages/convex-reader writes it into its .env.local; copy it here.",
    placeholder: "https://placeholder-not-a-deployment.convex.cloud",
  }),
  VITE_LOG_BACKEND: envField(z.enum(["console", "axiom", "both"]).optional(), {
    kind: "build",
    doc: 'Logging backend: "console" (default), "axiom" (POST to /api/log), or "both". An unrecognised value falls back to "console" with a one-time warning, never a throw. Read raw by src/logging/appLogging.ts, not through env.ts.',
    placeholder: "both",
  }),
  VITE_LOG_DEBUG: envField(z.string().optional(), {
    kind: "build",
    doc: 'Gate for Logger.debug(). Anything but exactly "true" leaves debug off. Read raw by src/logging/appLogging.ts, not through env.ts.',
    placeholder: "false",
  }),
  VITE_E2E_ZOOM_MOCK: envField(z.string().optional(), {
    kind: "build",
    doc: 'Exactly "true" swaps the Zoom Video SDK for the no-op mock in the orientation document, so an E2E run needs no Zoom account. Unset in every real build.',
    placeholder: "false",
  }),
  VITE_VOICE_FOLLOW: envField(z.enum(["vosk", "fake"]).optional(), {
    kind: "build",
    doc: 'Voice follow in the ear reader, off when unset (decided 2026-10-17): no toggle and no microphone. "vosk" offers a toggle that, once tapped, asks for the microphone and loads the Vosk model; "fake" offers one that drives the pointer with the package\'s scripted fake engine reading the page, with no microphone or model, for development and an E2E run.',
  }),
  VITE_VOICE_FOLLOW_MODEL_URL: envField(
    z
      .url()
      .refine((url) => /\/vosk-model-[^/]+\.(?:tar\.gz|tgz)$/i.test(url), {
        message: "must name a Vosk release archive, …/vosk-model-<name>.tar.gz",
      })
      .optional(),
    {
      kind: "build",
      doc: "Overrides the Vosk model archive voice follow loads (default https://cdn.sara.ai/models/vosk/vosk-model-small-en-us-0.15.tar.gz), for a developer serving one the CDN does not have. The archive's file name is the model's name, which the engine id carries into every result.",
    },
  ),
  VITE_APP_VERSION: envField(z.string().optional(), {
    kind: "injected",
    doc: "Application version stamped onto every log event's version field. Set by infra/scripts/deploy.ts from apps/reader/package.json at build time, never by a developer.",
  }),
});
